import { getUid } from '@smart-tv/utils/api-utils';

export interface CloseAllDeviceStreamsResponse {
  success: boolean;
  message: string;
}

const STREAM_FLOW_DEVICE_URL =
  process.env.NORLYS_STREAM_FLOW_API_URL;

export async function closeAllDeviceStreams(
  deviceUid: string = getUid()
): Promise<CloseAllDeviceStreamsResponse> {
  if (!deviceUid) {
    return { success: false, message: 'Missing device UID' };
  }

  const apiKey = process.env.NORLYS_STREAM_FLOW_API_KEY;
  if (!apiKey) {
    return { success: false, message: 'Missing STREAM_FLOW_API_KEY' };
  }

  const url = `${STREAM_FLOW_DEVICE_URL}/${encodeURIComponent(deviceUid)}`;

  try {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: {
        'X-API-KEY': apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(
        { 'progress': 1 }
      ),
    });

    if (!response.ok) {
      const rawText = await response.text().catch(() => '');
      const detail = rawText ? ` (${response.status})` : ` (${response.status})`;
      return {
        success: false,
        message: `Request failed${detail}`
      };
    }

    return {
      success: true,
      message: 'All streams closed'
    };
  } catch (error) {
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Request failed'
    };
  }
}

export default closeAllDeviceStreams;
